import React from 'react';

import SocialButton from './SocialButton';
import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';

interface Props {
  color?: string
}

export default class SocialButtonList extends React.Component<Props> {

  render() 
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const color = this.props.color || 'white';

    const general = data.generalParameters;

    const email = general.getValue('Email');
    const twitter = general.getValueOrNull('Twitter');
    const facebook = general.getValueOrNull('Facebook');
    const linkedin = general.getValueOrNull('Linkedin');

    return (
      <div className="flex flex-row">
        <SocialButton color={ color } service="email" url={ `mailto:${email}` } />
        <SocialButton color={ color } service="linkedin" url={ linkedin } />
        <SocialButton color={ color } service="twitter" url={ twitter } />
        <SocialButton color={ color } service="facebook" url={ facebook } />
      </div>
    );
  }

}